export default "__VITE_ASSET__$z6z7dXk__"